import React from 'react'
import styled from 'styled-components'

import {
  Button,
  Modal,
  ModalInjectedProps,
  Text,
  Markdown,
} from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

interface LicenseAgreementModalProps extends ModalInjectedProps {
  agreement: string
  agreeAction: () => void
  helpText?: string
}

const HelpText = styled(Text)`
  padding-left: 32px;
  padding-top: 12px;
  text-align: left;

  ${breakpoint('base', 'lg')`
    &&& {
        padding-top: 0;
        padding-left: 16px;
        width: 100%;
        padding-bottom: 12px;
  `}
`

const LicenseAgreementModalWide = styled(Modal)`
  display: flex;
  flex-direction: column;
  width: 60vw;
  max-width: 60vw;

  ${breakpoint('base', 'sm')`
    width: 100%;
    max-width: 100%;
  `}
`

const LicenseAgreementModalFooter = styled(Modal.Footer)`
  position: static;
  flex: none;

  ${breakpoint('base', 'lg')`
        text-align: left;
        flex-direction: column;
    `}
`

const LicenseAgreementModalBody = styled(Modal.Body)`
  overflow: auto;

  &:first-child {
    margin-top: 0 !important;
    padding-top: 20px !important;
  }

  p {
    padding-bottom: 0;
  }
`

export const LicenseAgreementModal: React.FCC<LicenseAgreementModalProps> = ({
  agreement,
  hideModal,
  agreeAction,
  helpText,
}) => {
  const handleClick = () => {
    agreeAction()
    hideModal()
  }

  return (
    <LicenseAgreementModalWide
      onCancel={hideModal}
      data-testid="license-agreement-modal"
    >
      <LicenseAgreementModalBody>
        <Markdown>{agreement}</Markdown>
      </LicenseAgreementModalBody>
      <LicenseAgreementModalFooter
        leftContent={<HelpText>{helpText}</HelpText>}
      >
        <Button onClick={hideModal}>Disagree</Button>
        <Button
          data-testid="agree-license"
          variant="primary"
          onClick={handleClick}
        >
          Agree
        </Button>
      </LicenseAgreementModalFooter>
    </LicenseAgreementModalWide>
  )
}
